import { Swiper, Pagination, Autoplay, Navigation } from 'swiper'

import './auto-content-slider.scss'

const initAutoContentSlider = () => {
  new Swiper('.acs__slider.swiper', {
    modules: [Pagination, Autoplay, Navigation],
    slidesPerView: 1,
    speed: 0,
    loop: true,

    pagination: {
      el: '.acs__slider-pagination.swiper-pagination',
      clickable: true,
    },

    navigation: {
      prevEl: '.acs__slider-navigation.prev',
      nextEl: '.acs__slider-navigation.next',
    },

    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      waitForTransition: false,
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initAutoContentSlider()
})
